import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { Icon, ICON_NAME } from 'b2b-components/theme/components/Icon';
import { upperCaseFirst } from 'b2b-apps/shop/common/utils/string/string';
import { ComponentType, Props } from './';
import './FailedProductBox.scss';

const FailedProductBox: ComponentType = ({
  styleType,
  children,
  className,
}: Props): ReactElement => {
  const rootClassName = classNames(
    'FailedProductBox',
    { [`FailedProductBox--${upperCaseFirst(styleType || '')}`]: styleType },
    className,
  );

  return (
    <div className={rootClassName}>
      <div className="FailedProductBox-ImagePlaceholder" />

      <div className="FailedProductBox-Message">
        <div className="FailedProductBox-IconBox">
          <Icon
            className='FailedProductBox-Icon'
            name={ICON_NAME.alertWarning}
          />
        </div>

        <div>{children}</div>
      </div>
    </div>
  );
};

export { FailedProductBox };
